import { createAction, props } from "@ngrx/store"
import { AccountStatementDto, BusinessNameDto, ChangePasswordDto, UserDto } from "./settings.dtos"
import { RoleState } from "./settings.reducers";

export const createUser = createAction(
  '[Settings Module] create user',
  props<{ userCreateDto: UserDto }>()
);
export const createUserSuccess = createAction('[Settings Module] STATUS: create user success', props<{ users: UserDto }>());
export const createUserFailed = createAction('[Settings Module] STATUS: create user failed');

export const fetchUsers = createAction('[Settings Module] fetch users', props<{ page?: any; limit?: any; filter?: any }>());
export const fetchUsersSuccess = createAction(
  '[Settings Module] STATUS: fetch users success',
  props<{ allUsers: UserDto[] }>()
);
export const fetchUsersFailed = createAction('[Settings Module] STATUS: fetch users failed');

export const editUser = createAction('[Settings Module] edit user', props<{ UsersDto: any }>());
export const editUserSuccess = createAction('[Settings Module] STATUS: edit user success', props<{ users: any }>());
export const editUserFailed = createAction('[Settings Module] STATUS: edit user failed');

export const deleteUser = createAction('[Settings Module] delete user', props<{ UsersDto: any }>());
export const deleteUserSuccess = createAction('[Settings Module] STATUS: delete user success', props<{ users: any }>());
export const deleteUserFailed = createAction('[Settings Module] STATUS: delete user failed');

export const createRole = createAction('[Settings Module] create role', props<{ RoleDto: any }>());
export const createRoleSuccess = createAction('[Settings Module] STATUS: create role success', props<{ userRoles: any }>());
export const createRoleFailed = createAction('[Settings Module] STATUS: create role failed');

export const editRole = createAction('[Settings Module] edit role', props<{ RoleDto: any }>());
export const editRoleSuccess = createAction('[Settings Module] STATUS: edit role success', props<{ RoleDto: any }>());
export const editRoleFailed = createAction('[Settings Module] STATUS: edit role failed');

export const fetchRoles = createAction('[Settings Module] fetch roles', );
export const fetchRolesSuccess = createAction(
  '[Settings Module] STATUS: fetch roles success',
  props<{ allRoles: RoleState[] }>()
);
export const fetchRolesFailed = createAction('[Settings Module] STATUS: fetch roles failed');



export const editBusinessName = createAction(
    '[Settings Module] edit business name',
    props<{businessNameDto: BusinessNameDto}>()
)

export const editBusinessNameFailed = createAction(
    '[Settings Module] STATUS: edit business name failed'
)

export const editBusinessNameSuccess = createAction(
    '[Settings Module] STATUS: edit business name success'
)

export const changePassword = createAction(
    '[Settings Module] change password',
    props<{changePasswordDto: ChangePasswordDto}>()
)

export const changePasswordFailed = createAction(
    '[Settings Module] STATUS: change password failed'
)

export const changePasswordSuccess = createAction(
    '[Settings Module] STATUS: change password success'
)


export const generateAccountStatement = createAction(
    '[Settings Module] generate account statement',
    props<{accountStatementDto: AccountStatementDto, documentType: string, walletNumber: string}>()
)

export const generateAccountStatementFailed = createAction(
    '[Settings Module] STATUS: generate account statement failed'
)

export const generateAccountStatementSuccess = createAction(
    '[Settings Module] STATUS: generate account statement success'
)